import { render, staticRenderFns } from "./TopInvestor2.vue?vue&type=template&id=95892302&scoped=true&"
import script from "./TopInvestor2.vue?vue&type=script&lang=js&"
export * from "./TopInvestor2.vue?vue&type=script&lang=js&"
import style0 from "./TopInvestor2.vue?vue&type=style&index=0&id=95892302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95892302",
  null
  
)

export default component.exports